/**
 * Valor por defecto para imagen
 */
export const imagen = () => {
  return {
    id: null,
    id_empresa: null,
    nombre: null,
    nombre_original: null,
    archivo: null
  };
};

/**
 * Valor por defecto para empresa
 */
export const empresa = () => {
  return {
    banner: 0,
    boton_banner: ''
  };
};

/**
 * Valor por defecto para filtros
 */
export const filtros = () => {
  return {
    id_empresa: null,
    paginar: false,
    activo: null,
    cantidad: 10,
    page: 1
  };
};


/**
 * Variables
 */
export default {
  empresa: empresa(),
  imagenes: {
    data: []
  },
  imagenes_banner: [],
  imageBannerActive: null,
  imagen: imagen(),
  empresas: [],
  empresas_filtro: [],
  cargando_datos_select: false,
  filtros: filtros(),
  modal: {
    mostrar: false
  },
  modal_imagen: {
    mostrar: false
  },
  modal_banner: {
    mostrar: false
  },
  inputEmpresas: {
    ids: []
  },
  cargarEmpresas: []
};
